import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AsksuiteCitrusModule, ThemeService } from 'asksuite-citrus';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [
    SharedModule,
    CommonModule,
    AsksuiteCitrusModule
  ],
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss'
})
export class TestComponent {
  title = 'testes-angular';
  isSelected = false;
  isDisabled = false;
  isWide = false;
  currTheme = 'dark';

  appearances = [
    { appearance: 'brand', inverse: false },
    { appearance: 'opaque', inverse: false },
    { appearance: 'opaque-inverse', inverse: true },
    { appearance: 'transparent', inverse: false },
    { appearance: 'transparent-inverse', inverse: true },
    { appearance: 'outline', inverse: false },
    { appearance: 'outline-inverse', inverse: true },
  ] as const;
  sizes = ['smallest', 'small', 'medium', 'large', 'larger'] as const;
  shapes = ['square', 'rounded'] as const;
  icons = ['icon', 'icon-text-icon', 'icon-icon'] as const;
  iconNames = ['email', 'phone', 'chatweb', 'whatsapp', 'instagram', 'facebook'] as const;
  iconAppearances  = ['grey', 'contrast', 'default', 'inverse'] as const;

  constructor(private theme: ThemeService){}

  select() {
    this.isSelected = !this.isSelected;
  }
  disable() {
    this.isDisabled = !this.isDisabled;
  }
  wide() {
    this.isWide = !this.isWide;
  } 
  darkMode(){
    this.currTheme = this.currTheme === 'dark' ? 'light' : 'dark'
    this.theme.setTheme(this.currTheme as any);
  }
}
